import React from 'react';

const AnnouncementSvg = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d={`
        M23.7729 17.3894C25.8926 17.3894 27.611 15.671 27.611 13.5513C27.611 11.4315 25.8926
        9.71313 23.7729 9.71313C21.6531 9.71313 19.9347 11.4315 19.9347 13.5513C19.9347 15.671
        21.6531 17.3894 23.7729 17.3894Z`}
      fill="#FF969C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={`
        M23.6523 4.98114C23.73 5.13606 23.7713 5.30675 23.7729 5.4801V21.6223C23.7718 22.0046 23.5717
        22.3587 23.2447 22.5568C22.9178 22.755 22.5113 22.7686 22.1718 22.5928L14.2214
        18.4859H10.1913V8.61642H14.2214L22.1718
        4.50959C22.4306 4.37525 22.7322 4.34947 23.01 4.43796C23.2878 4.52644 23.5189 4.7219 23.6523
        4.98114ZM5.67876 9.71309V17.3894H3.48553C2.87989 17.3894 2.38892 16.8984 2.38892 16.2928V10.8097C2.38892
        10.2041 2.87989 9.71309 3.48553 9.71309H5.67876Z`}
      fill="#EC111A"
    />
    <path
      d={`
        M6.22706 18.486C5.62142 18.486 5.13045 17.995 5.13045 17.3894V9.71307C5.13045 9.10743 5.62142
        8.61646 6.22706 8.61646H11.1618V18.486L13.3551 24.1226C13.4603 24.3945 13.453 24.6971 13.3347
        24.9636C13.2164 25.2301 12.9968 25.4385 12.7245 25.5427C12.5979 25.5885 12.4644 25.6126 12.3297
        25.614H10.3997C9.94555 25.6149 9.53783 25.3358 9.37435 24.9121L6.90148 18.486H6.22706Z`}
      fill="#A6000E"
    />
  </svg>
);

export default AnnouncementSvg;
